import { BadgeDomain } from "./BadgeDomain";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export function BadgeDomainWithTooltip({
  children,
  bg,
  onClick,
  className,
  size,
  truncateRow,
  tooltip,
  placement = "top",
  delay = { show: 150, hide: 300 }
}) {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {tooltip}
    </Tooltip>
  );

  return (
    <OverlayTrigger
      placement={placement}
      delay={delay}
      overlay={renderTooltip}
    >
      <span>
        <BadgeDomain
          bg={bg}
          onClick={onClick}
          className={className}
          size={size}
          truncateRow={truncateRow}
        >
          {children}
        </BadgeDomain>
      </span>
    </OverlayTrigger>
  );
}
